import useCanAccess from './useCanAccess';
import roles from '../utils/constants/roles';

const useProRole = () => {
  const canAccess = useCanAccess([roles.PRO, roles.BUSINESS_PLAN]);
  return canAccess;
};

export default useProRole;
